
angular.module('mtic.components.dashboards.teacher_general')
.component('teacherClassesSchools', {
  templateUrl: 'template.html',
  bindings: {
  },
  controllerAs: '$ctrl',
  controller($scope, $log, language, EventManager, TeacherDataService, LocaleService) {
    var eventManager = new EventManager('teacherClassesSchools', $scope);
    $scope.language = language;
    $scope.getTranslation = function(slug){
      return language.get(slug);
    }
    const $ctrl = this;
    const text = $scope.text = {
      SCHOOL: 'School',
      MODULES: 'Module',
      CLASSES: 'Classes',
      ACCOUNTSETUPISBAD: 'Your account appears to not be configured correctly.'
    }
    $ctrl.flags = {
      loading: true,
      error: null,
      reset() {
        this.loading = true;
        this.error = null;
      },
      done(error) {
        this.loading = false;
        if(error) {
          this.error = error;
        }
      }
    }
    $scope.archivedSection = {
      showingArchivedClasses:false,
      hasArchived:true
    }

    $ctrl.schools = {
      list: [],
      hasMany: false,
      hasNone: false,
      filter: {},
      selected: null
    }
    $ctrl.classes = {
      list:[]
    }

    var getSchools = function(reset=false) {
      return TeacherDataService.getUserSchools(null, reset).
      then( function(schools){
        $ctrl.schools.list = schools;
        $ctrl.schools.hasMany = schools.length > 1;
        $ctrl.schools.hasNone = schools.length < 1;
        $ctrl.schools.selected = schools[0];
      })
    }

    $scope.isLux = LocaleService.getCurrentLocale() === 'LUXEMBOURG';

    $scope.openEditClassStatus = function(){
      $scope.openedEditClassStatusMode=!$scope.openedEditClassStatusMode;
      if($scope.openedEditClassStatusMode){
        eventManager.broadcast("edit:class:status:mode:on");
      }else{
        eventManager.broadcast("edit:class:status:mode:off");
      }
    }

    $ctrl.$onInit = function(){
      $ctrl.flags.reset();
      getSchools(true)
      .then( function() {
        $ctrl.flags.done()
      })
      .catch( function(err) {
        $log.error(err);
        $ctrl.flags.done(err.message);
      });
    };

  }
});
